import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: 'https://www.instagram.com/aibrasil.ai/', label: 'Instagram' },
    { icon: Linkedin, href: 'https://www.linkedin.com/company/ai-brasil-ai/', label: 'LinkedIn' },
    { icon: Youtube, href: 'https://www.youtube.com/@ai_brasil__ai', label: 'YouTube' },
  ];

  const footerLinks = [
    {
      title: 'Membership',
      links: [
        { label: 'Ser Membro', href: '#membership' },
        { label: 'Espaços', href: '#spaces' },
        { label: 'Quiz', href: '#quiz' },
        { label: 'Eventos', href: '#events' },
      ],
    },
    {
      title: 'Recursos',
      links: [
        { label: 'Blog', href: 'https://ai.eco.br/blog' },
        { label: 'Eventos', href: 'https://ai.eco.br/events' },
        { label: 'Podcast', href: 'https://ai.eco.br/podcast' },
        { label: 'Newsletter', href: 'https://ai.eco.br/newsletter' },
      ],
    },
    {
      title: 'Comunidade',
      links: [
        { label: 'Membros', href: 'https://ai.eco.br/members' },
        { label: 'Meetups', href: 'https://ai.eco.br/meetups' },
        { label: 'Mentores', href: 'https://ai.eco.br/mentors' },
        { label: 'Cases', href: 'https://ai.eco.br/cases' },
      ],
    },
    {
      title: 'Empresa',
      links: [
        { label: 'Sobre', href: 'https://ai.eco.br/about' },
        { label: 'Contato', href: 'https://ai.eco.br/contact' },
        { label: 'Privacidade', href: 'https://ai.eco.br/privacy' },
        { label: 'Termos', href: 'https://ai.eco.br/terms' },
      ],
    },
  ];

  return (
    <footer className="relative bg-surface-dark border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top Section */}
        <div className="grid lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <motion.a
              href="/"
              className="flex items-center gap-2 mb-4"
              whileHover={{ scale: 1.02 }}
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_ai-brasil-plans/artifacts/1kp6ef16_aibrasil_logo.png" 
                alt="AI Brasil" 
                className="h-14 w-auto"
              />
            </motion.a>
            <p className="text-white/60 text-sm mb-6">
              O maior movimento de democratização da inteligência artificial do Brasil.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-neon-green hover:border-neon-green/30 transition-all"
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-outfit font-bold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/60 hover:text-neon-green transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-white/40 text-sm pt-8 border-t border-white/10">
          <p>© {currentYear} AI Brasil. Todos os direitos reservados.</p>
          <p>
            Feito com{' '}
            <span className="text-neon-green">♥</span> para o ecossistema brasileiro de IA.
          </p>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-green/20 to-transparent" />
    </footer>
  );
};

export default Footer;
